import { render, staticRenderFns } from "./ModalExibirJustificativa.vue?vue&type=template&id=65681c86"
import script from "./ModalExibirJustificativa.vue?vue&type=script&lang=js"
export * from "./ModalExibirJustificativa.vue?vue&type=script&lang=js"
import style0 from "./ModalExibirJustificativa.vue?vue&type=style&index=0&id=65681c86&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports